module.exports = __webpack_public_path__ + "img/s2.a9a75ee3.png";